import React, { useEffect, useState } from "react";
import { MISformP1, MISformP10, MISformP11, MISformP12, MISformP13, MISformP14, MISformP15, MISformP16, MISformP17, MISformP18, MISformP19, MISformP2, MISformP20, MISformP21, MISformP22, MISformP23, MISformP24, MISformP25, MISformP26, MISformP3, MISformP4, MISformP5, MISformP6, MISformP7, MISformP8, MISformP9 } from "../../../core/data/json/MIS_Forms";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getOneMISApplicationDetails } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import ApplicationTimelineModal from "../../application/ApplicationTimeLineModal";

const MISPreviewScreen: React.FC = () => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [comment, setComment] = useState<string>("");
  const [applicationData, setApplicationData] = useState<any>([]);
  const [originalData, setOriginalData] = useState<any>([]);
  const [transactions, setTransactions] = useState<any[]>([]);
  
  const token = useSelector((state: any) => state.auth.token);
  const location = useLocation();
  const { applicationId, headerId } = location.state || {};

  const getDataField = () => {
    const typeNum = headerId;
    
    switch (typeNum) {
      case "f8dd542e-637b-48a9-9579-c51d955958f6":
        return MISformP1;
      case "ff834af9-ec91-4b64-be9d-8d6431318d60":
        return MISformP2;
      case "03272304-d1c1-4de3-80d5-41cc38d92c4e":
        return MISformP3;
      case "4e3264d9-5849-48c2-adb8-8f365ca9b619":
        return MISformP4;
      case "d662fb80-e724-4295-84a7-2335043045e6":
        return MISformP5;
      case "4abc0a84-c79c-487e-9459-d5bfda288209":
        return MISformP6;
      case "3542455a-a9fe-44cb-b582-bc6645cabd13":
        return MISformP7;
      case "60f185c0-0e2f-45e8-8589-0ee7c5b30720":
        return MISformP8;
      case "e8e3723e-fc9c-42a8-8e93-8003fdfa384f":
        return MISformP9;
      case "19f2c32b-8727-4c56-bb5f-f2ddab040130":
        return MISformP10;
      case "c34fc166-a42d-4c35-9ce7-caf23b63cc38":
        return MISformP11;
      case "26d4a5d5-5ca2-4188-8469-1add4e7b798f":
        return MISformP12;
      case "03f686ae-0289-4567-abe4-611f054fc460":
        return MISformP13;
      case "1be7aa2e-c4b4-4eaf-8a39-714ee69751ca":
        return MISformP14;
      case "49bb7b6e-2c1d-46c5-90ef-d74d63b323f0":
        return MISformP15;
      case "d3732eaf-9f80-4fc3-8431-e53951c21e2a":
        return MISformP16;
      case "d1ac3935-3f20-4740-9538-f6a641a75496":
        return MISformP17;
      case "5985a467-617e-4feb-a33f-f40f947f2c0e":
        return MISformP18;
      case "f0a5a49e-a89f-4536-88d7-4a5ac74a4a1a":
        return MISformP19;
      case "204d4e1b-e3da-4bea-b011-c00de370ee82":
        return MISformP20;
      case "f1abc58d-2016-477e-92bf-ad2a68c83bc8":
        return MISformP21;
      case "ccbd3a6c-80ec-4d9b-a3a0-ee0461f428a7":
        return MISformP22;
      case "e793e2b8-7f7c-489d-91af-70cbd2af1b3a":
        return MISformP23;
      case "2e9b4f1d-2cd3-4f18-89a3-c1cf54edf005":
        return MISformP24;
      case "cc5c3eda-4bb2-422e-a540-18e3c1e4ff57":
        return MISformP25;
      case "35871e1f-26bc-4c6c-82cd-c5b8be6561f7":
        return MISformP26;
      default:
        return [];
    }
  };
    const [loading, setLoading]=useState<boolean>(false);
  
  const misForm = getDataField();

  // Check if a row has all null/empty values (excluding metadata fields)
  const isRowEmpty = (row: any) => {
    // Fields to exclude from null check (metadata fields)
    const excludeFields = ['id', 'masterId', 'createdAt', 'updatedAt'];
    
    // Get all fields from the row
    const dataFields = Object.keys(row).filter(key => !excludeFields.includes(key));
    
    // Check if all data fields are null or empty
    return dataFields.every(field => {
      const value = row[field];
      return value === null || value === undefined || value === '';
    });
  };

  // Reconstruct the original/oldest data by starting from the oldest transaction
  const reconstructOriginalData = (currentDetails: any[], transactions: any[]) => {
    if (!transactions || transactions.length === 0) {
      // Filter out empty rows even if there are no transactions
      return currentDetails.filter(row => !isRowEmpty(row));
    }

    // Clone the current details as starting point
    const reconstructedData = JSON.parse(JSON.stringify(currentDetails));
    
    // Traverse transactions from oldest (index 0) to newest (n-1)
    // Start from the beginning and move forward
    for (let i = 0; i < transactions.length; i++) {
      const transaction = transactions[i];
      
      // Apply old values from reSubmittedFieldsOldVal
      if (transaction?.reSubmittedFieldsOldVal && Array.isArray(transaction.reSubmittedFieldsOldVal)) {
        transaction.reSubmittedFieldsOldVal.forEach((oldField: any) => {
          const detailIndex = reconstructedData.findIndex(
            (item: any) => item.id === oldField.detailId
          );
          
          if (detailIndex !== -1) {
            // Replace with the old value
            reconstructedData[detailIndex][oldField.columnName] = oldField.oldValue;
          }
        });
      }
    }

    // Filter out rows where all data fields are null/empty
    return reconstructedData.filter(row => !isRowEmpty(row));
  };

const fetchApplicationDetails = async () => {
    try {
      setLoading(true);
      const response = await getOneMISApplicationDetails(applicationId, headerId, token);
      
      const details = response.data.details;
      const transactionList = response.data.transaction || [];
      const status = response.data.status;
      
      setApplicationData(details);
      setTransactions(transactionList);
      
      // If status contains "approved", show latest data; otherwise show original data
      if (status && status.toLowerCase().includes("approved")) {
        // Show latest data - filter out empty rows
        const latestData = details.filter((row: any) => !isRowEmpty(row));
        setOriginalData(latestData);
       
      } else {
        // Reconstruct original data
        const original = reconstructOriginalData(details, transactionList);
        setOriginalData(original);
       
      }

    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplicationDetails();
  }, []); 

  return (
    <>
    {loading?(
      <div className="page-wrapper p-3 mt-5">
    <div className="d-flex justify-content-center align-items-center py-4">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
</div>
    ):    (
      <div className="page-wrapper p-3 mt-5">
        <h3 className="mb-0">
          Agricultural Produce Market Committees Report Showing the Status Of
          Regulated Markets For The Year Ending 31/03/2025
        </h3>
        
        {/* Transaction Info */}
        {/* {transactions.length > 0 && (
          <div className="alert alert-info mt-3">
            <strong>Showing Original Data:</strong> Reconstructed from {transactions.length} transaction(s).
            This displays the data as it was when first submitted, before any modifications.
          </div>
        )} */}

        <div className="mt-4 mb-5">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-dark">
                {/* First Header Row */}
                <tr>
                  <th rowSpan={2} style={{ minWidth: "50px", verticalAlign: "middle", border: "1px solid black" }}>
                    Sr.No.
                  </th>
                  {misForm.map((field, index) => (
                    <th
                      key={index}
                      colSpan={field.response.length > 1 ? field.response.length : undefined}
                      rowSpan={field.response.length === 1 ? 2 : undefined}
                      style={{
                        minWidth: "150px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        textAlign: "center",
                        verticalAlign: "middle",
                        border: "1px solid black"
                      }}
                    >
                      {field.fieldVal}
                    </th>
                  ))}
                </tr>
               
                {/* Second Header Row - Only for multi-response fields */}
                <tr>
                  {misForm.map((field, fieldIndex) => (
                    <React.Fragment key={fieldIndex}>
                      {field.response.length > 1 && field.response.map((resp, respIndex) => (
                        <th
                          key={respIndex}
                          style={{
                            minWidth: "120px",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            textAlign: "center",
                            border: "1px solid black"
                          }}
                        >
                          {resp.responseName}
                        </th>
                      ))}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
 
              <tbody>
                {originalData.map((item: any, index: number) => (
                  <tr key={item.id}>
                    <td style={{ textAlign: "center",border: "1px solid black" }}>{index + 1}</td>
                    {misForm.map((field, fieldIndex) => (
                      <React.Fragment key={fieldIndex}>
                        {field.response.map((resp, respIndex) => (
                          <td
                            key={respIndex}
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              padding: "0.75rem",
                              border: "1px solid black"
                            }}
                          >
                            {item[resp.fieldName as keyof typeof item] !== null 
                              ? item[resp.fieldName as keyof typeof item] 
                              : "-"}
                          </td>
                        ))}
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      )}
      {/* <ApplicationTimelineModal comments={transactions} /> */}
    </>
  );
};
 
export default MISPreviewScreen;